import { type Place } from '../../model/Place';

// TODO: The Place object needs to be cleaned up. Sometimes we normalize the Place object,
// adding an address object to it, rather than using the address properties directly.
// For example, see the useCustomers hook.
// I think we should get rid of the normalization and use the object as close to the BE as possible.

export const placeToAddressString = (place: Place): string => {
  const streetInfo = [
    place.street_name || place.address?.street_name,
    place.street_number || place.address?.street_number,
  ]
    .filter(Boolean)
    .join(', ');

  const firstPart = streetInfo || place.name || place.address?.full_address;

  const addressParts = [
    firstPart,
    place.zip_code || place.address?.zip_code,
    place.city || place.address?.city,
    place.country_name || place.address?.country_name,
  ];

  const address = addressParts.filter(Boolean).join(', ');
  if (!address) {
    return place.full_address || place.address?.full_address || '';
  }
  return address;
};
